import React, { useEffect, useState } from "react";
import { Card, CardBody, Row, Col, Input } from "reactstrap";
// import axios from "axios";
import api from "../../services/api";
import { setBreadcrumbItems } from "../../store/actions";
import TechnologyCards from "./TechnologiesCards";
import { MutatingDots } from "react-loader-spinner";
import { connect } from "react-redux";
import "./CourseCards.css"; 

const CourseCards = (props) => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [courseRegistrations, setCourseRegistrations] = useState([]);
  const [visibleTechnologyCards, setVisibleTechnologyCards] = useState(false);
  const [technologies, setTechnologies] = useState([]);
  const [selectedCourseName, setSelectedCourseName] = useState("");
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [courseProgramsLoader, setCourseProgramsLoader] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [originalCourses, setOriginalCourses] = useState([]);
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("authUser")));
  console.log("User Data:", user);
  const breadcrumbItems = [
    { title: "Technical Hub", link: "#" },
    { title: "Payments", link: "#" },
    { title: "Course Payments", link: "#" },
  ];

  useEffect(() => {
    fetchCoursePrograms();
    props.setBreadcrumbItems("Course Payments", breadcrumbItems);
  }, []);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setCourseRegistrations(originalCourses);
    } else {
      const filteredCourses = originalCourses.filter((course) =>
        course.course_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        course.passout_year.toString().includes(searchQuery)
      );
      setCourseRegistrations(filteredCourses);
    }
  }, [searchQuery, originalCourses]);

  const fetchCoursePrograms = async () => {
    try {
      if(user && user.role === 'cashier'){
        console.log("Fetching course programs for Cashier:", user.name);
        const response = await api.post(`${backendUrl}get-course-programs-by-cashier`, { cashier_name: user?.first_name });
        if (response.status === 200) {
          setOriginalCourses(response.data.courseRegistrations);
          setCourseRegistrations(response.data.courseRegistrations);
          setCourseProgramsLoader(false);
        }
        return;
      }
      const response = await api.get(`${backendUrl}get-course-programs`);
      if (response.status === 200) {
        setOriginalCourses(response.data.courseRegistrations);
        setCourseRegistrations(response.data.courseRegistrations);
        setCourseProgramsLoader(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  console.log("Course Registrations:", courseRegistrations);
  const handleFetchTechnologies = async (id, passout_year, course_name) => {
    setLoading(true);
    try {
      const response = await api.get(
        `${backendUrl}get-technologies-by-course-registration/${id}/${user?.first_name}?passout_year=${passout_year}`,
      );
      if (response.status === 200) {
        setTechnologies(response.data.technologies);
        setSelectedCourseId(id);
        setSelectedCourseName(course_name);
        setVisibleTechnologyCards(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const cardColors = [
    "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
    "linear-gradient(135deg, #10b981 0%, #3b82f6 100%)",
    "linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)",
    "linear-gradient(135deg, #06b6d4 0%, #3b82f6 100%)",
    "linear-gradient(135deg, #ec4899 0%, #8b5cf6 100%)",
  ];

  return (
    <div className="modern-page-container">
      <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-3">
        <h1 className="page-title">Course Payments</h1>
        <div className="search-box">
          <Input
            type="text"
            placeholder="Search course name or passout year..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      {courseProgramsLoader && courseRegistrations.length === 0 ? (
        <div className="loader-wrapper">
          <MutatingDots
            visible
            height="100"
            width="100"
            color="#6366f1"
            secondaryColor="#8b5cf6"
            radius="12.5"
            ariaLabel="mutating-dots-loading"
          />
        </div>
      ) : (
        <>
          <h4 className="fw-bold text-secondary mb-3">Select a Course Program</h4>

          <Row className="g-4">
            {courseRegistrations
              .sort((a, b) => a.order - b.order)
              .map((ele, key) => (
                <Col
                  xl={3}
                  sm={6}
                  key={key}
                  onClick={() =>
                    handleFetchTechnologies(
                      ele.course_id,
                      ele.passout_year,
                      ele.course_name
                    )
                  }
                >
                  <Card
                    className="modern-course-card"
                    style={{
                      background: cardColors[key % cardColors.length],
                    }}
                  >
                    <CardBody className="p-4">
                      <h5 className="fw-bold text-white text-uppercase mb-2">
                        {ele.course_name}
                      </h5>
                      <p className="text-white-50 mb-1">
                        Passout Year: {ele.passout_year}
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              ))}
          </Row>
        </>
      )}

      {visibleTechnologyCards ? (
        <div className="mt-5 fade-in">
          <TechnologyCards
            course_id={selectedCourseId}
            technologies={technologies}
            course_name={selectedCourseName}
          />
        </div>
      ) : (
        loading && (
          <div className="loader-wrapper mt-4">
            <MutatingDots
              height="100"
              width="100"
              color="#6366f1"
              secondaryColor="#8b5cf6"
              radius="12.5"
              ariaLabel="mutating-dots-loading"
              visible={true}
            />
          </div>
        )
      )}
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(CourseCards);
